import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarredContactsZeroState4Icon = (props: IconProps) => (
  <Icon height="32px" width="32x" viewBox="0 0 32 32" {...props}>
    <rect width="32" height="32" fill="#E5F2FF" rx="16" />
    <mask id="a" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse">
      <circle cx="16" cy="16" r="16" fill="#B94C24" />
    </mask>
    <g mask="url(#a)">
      <path fill="#FF9500" d="M-5.12-6.08h63.36V54.4H-5.12z" />
      <path
        fill="#fff"
        d="M10.723 27.524S5.628 31 4.159 45.947C3.129 56.42 2.24 60.1 2.24 60.1l3.003.044s5.87-14.667 6.401-21.177c.25-3.073-.921-11.436-.921-11.436v-.006ZM21.687 27.389s5.913 2.309 7.209 18.136c.856 10.482 1.74 14.574 1.74 14.574l-3.003.044s-5.87-14.667-6.401-21.177c-.25-3.073.46-11.577.46-11.577h-.005Z"
      />
      <path
        fill="#fff"
        d="M14.652 26.272c-1.918.12-4.032.456-4.623 2.461-.396 2.732.91 11.464-.742 20.396-2.326 12.575-1.827 26.2-1.827 26.2l18.336.136s.233-13.756-1.648-26.2c-1.273-8.423-.216-16.738-1.403-20.537-.624-2-3.621-2.195-4.64-2.456-1.23-.514-1.821-.102-3.453 0Z"
      />
      <path
        fill="#323232"
        d="M27.737 14.505c0 6.364-5.16 11.524-11.523 11.524-6.364 0-11.524-5.16-11.524-11.524 0-6.363 5.16-11.523 11.523-11.523 6.364 0 11.524 5.16 11.524 11.523Z"
      />
      <path
        fill="#323232"
        d="M12.728 19.324s-.434-2.396.336-3.876c.965-1.859 3.843-2.883 6.06-.905 1.545 1.377.732 5.014.732 5.014l-4.835-2.054-2.293 1.816v.005Z"
      />
      <path
        fill="#653D2E"
        d="M18.105 26.272s-2.027 1.074-3.453 0l.304-3.718H17.8l.304 3.718ZM13.335 18.907s-.407-.266-.727.157c-.314.422-.103 2 .683 2s.038-2.157.038-2.157h.006ZM19.444 18.907s.406-.266.726.157c.314.422.108 2-.683 2s-.038-2.157-.038-2.157h-.006Z"
      />
      <path
        fill="#653D2E"
        d="M19.574 18.468c0-1.773-1.431-2.933-3.198-2.933s-3.198 1.16-3.198 2.933c0 0-.14 2.26-.14 2.373 0 1.686 2.064 3.822 3.338 3.822 1.474 0 3.339-2.548 3.339-3.822 0-.108-.141-2.373-.141-2.373Z"
      />
      <path
        fill="#fff"
        d="M13.265 22.05s.043-.01.065-.021l-.076-.185s-.027.011-.038.011a.668.668 0 1 1-.347-1.29l-.049-.19a.866.866 0 0 0-.612 1.057.873.873 0 0 0 1.062.613l-.005.005ZM19.455 22.05s-.049-.016-.076-.027c.022.006.081-.179.081-.179.017 0 .033.011.044.016a.668.668 0 1 0 .346-1.29l.05-.19a.87.87 0 0 1 .612 1.058.873.873 0 0 1-1.063.612h.006Z"
      />
    </g>
  </Icon>
);

export default memo(StarredContactsZeroState4Icon);
